module.exports = __webpack_public_path__ + "img/defr_ceremonie_deformation.7cbf5dbe.jpg";